export default __webpack_public_path__ + "static/media/resume.af766007.pdf";